import { useMemo } from 'react';
import { useGetCatalogQuery, useUpdateAddressMutation } from '../graphql';
import { useUpdateAddressForm } from './useAddressFormModal';

export const useController = ({
  onCompleted,
  onCloseModal,
  address,
}) => {
  const { data: catalogData } = useGetCatalogQuery();

  const states = catalogData?.catalogs.states;

  const statesMap = useMemo(() => states?.reduce(
    (acc, state) => (
      { ...acc, [state.constId]: { name: state.name, id: state.id } }
    ),
    {},
  ), [states]) || {};

  const [updateAddressMutation, { loading: isSubmitting }] = useUpdateAddressMutation({
    onCompleted: () => {
      onCompleted();
      onCloseModal();
    },
  });

  const {
    control,
    zipError,
    onSubmit,
    neighborhoods,
  } = useUpdateAddressForm({
    address,
    statesMap,
    updateAddressMutation,
  });

  return {
    control,
    zipError,
    onSubmit,
    isSubmitting,
    neighborhoods,
  };
};
